import React from 'react';
import LoginForm from 'auth/LoginForm';

import * as routes from 'app/routes';
import Box from 'common/Box';
import Link from 'common/Link';

export default () => (
  <div className="Login">
    <h1>Sign in</h1>
    <LoginForm />

    <Box>
      Forgot your password? Never set one?
      {' '}
      <Link to={routes.resetPassword()}>
        Set a new password here
      </Link>
    </Box>
  </div>
);
